import axios from 'axios';

// Support for both Vite and Create React App environments
const BASE_URL = import.meta.env?.VITE_API_BASE_URL || process.env.REACT_APP_API_BASE_URL;

const contactService = {
  
  // 1. LIST (GET)
  getAllContact: async () => {
    try {
      const response = await axios.post(`${BASE_URL}/contactUs/list`);
      
      /** * CHANGE HERE: 
       * Your backend returns: { success: true, data: [...] }
       * We need to return response.data.data
       */
      if (response.data && response.data.success) {
        return response.data.data; 
      }
      
      return [];
    } catch (error) {
      console.error("Fetch Error:", error);
      throw error.response?.data || "Could not fetch projects";
    }
  },

  // 2. CREATE (POST)
  createContact: async (formData) => {
    try {
      const response = await axios.post(`${BASE_URL}/contactUs/create`, formData, {
        headers: {
        'Content-Type': 'application/json'
      }
      });
      
      return response.data;
    } catch (error) {
      throw error.response?.data || "Error adding project";
    }
  },

  // 3. UPDATE (POST)
  updateContact: async (id, formData) => {
    try {
      // Ensure the ID is passed correctly in the URL
      const response = await axios.post(`${BASE_URL}/contactUs/update/${id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || "Error updating project";
    }
  },

  // 4. DELETE (POST)
  deleteContact: async (id) => {
    try {
      const response = await axios.post(`${BASE_URL}/contactUs/delete/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || "Error deleting project";
    }
  }
};

export default contactService;